<template>
  <div class="asc-gdrp-notification-wrapper">
    <asc-notification
      class="asc-gdrp-notification-wrapper"
      :definition="definition"
      :on-close="handleClose"
    ></asc-notification>
  </div>
</template>

<script>
import AscNotification from '@/components/molecules/AscNotification'

export default {
  name: 'AscGdprNotification',

  components: {
    AscNotification,
  },

  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      definition: [
        {
          mode: 'alert',
          type: 'warning',
          position: 'bottom',
          icon: 'mdi-alert-circle',
          multiLine: true,
          text: 'This site uses cookies. By continuing to use it you are agreeing to use cookies. For more information on how we use cookies, go to our <a href="https://www.collinsaerospace.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>. In addition to the information provided in the Collins Aerospace Privacy Notice, we will be tracking user activity on the Ascentia website for export control and website development purposes.',
        },
      ],
    }
  },

  methods: {
    handleClose() {
      if (this.onClose) this.onClose()
    },
  },
}
</script>

<style lang="scss">
.asc-gdrp-notification-wrapper {
  z-index: 2;
  position: absolute;
  width: 100%;
  bottom: 20px;

  .asc-notification-wrapper {
    position: relative;
    margin: 0 auto;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.17);

    .asc-notification .wrapper {
      background-color: $gray-300;

      .content-wrapper {
        border-color: $gray-100;

        .content {
          a {
            color: $accent-700;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 944px) {
  .asc-gdrp-notification-wrapper {
    .asc-notification-wrapper {
      width: 69%;
    }
  }
}
</style>
